import { Metamodel } from 'app/model/base/model';
import { SqlCopySource } from './sql.copysource';
import { AzureSqlTableDataset } from 'app/model/dataset/azure-sql-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureSql.copySourceType,
    display: [],
    tags: { datasetModel: [Metamodel.modelFor(AzureSqlTableDataset)] }
})
export class AzureSqlCopySource extends SqlCopySource {
    public constructor() {
        super();
        this.queryTimeout = 120;
    }
}
